import type { DialogProps } from "@mui/material";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppMarkdownParser } from "../../../../shared/components/AppMarkdownParser";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { selectSelectedStylist } from "../../redux/selectors";
import styles from "./styles.module.css";

interface Props extends DialogProps {
  handleClose: () => void;
}

export const StylistMarkdownModal: React.FC<Props> = ({
  handleClose,
  ...props
}) => {
  const { t } = useTranslation();
  const textRef = useRef<HTMLDivElement>(null);
  const selectedStylist = useAppSelector(selectSelectedStylist);

  const RESULT = selectedStylist?.value.stylist_object.result as string;

  const handleCopyToClipboard = () => {
    navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([textRef.current?.innerHTML as string], {
          type: "text/html",
        }),
      }),
    ]);
  };

  return (
    <ModalBasic
      title="Markdown"
      buttonOkText={t("stylist.modal_markdown_ok_button")}
      onOk={handleCopyToClipboard}
      onCancel={handleClose}
      hasCloseButton
      hasFooter
      closeModal={handleClose}
      onClose={handleClose}
      {...props}
    >
      <div ref={textRef} className={styles.body}>
        {RESULT === "" ? (
          <div className={styles.empty}>
            {t("stylist.modal_markdown_empty")}
          </div>
        ) : (
          <AppMarkdownParser content={RESULT} />
        )}
      </div>
    </ModalBasic>
  );
};
